import type { ReactNode } from 'react';
import './workbench.css';

export function Workbench({
  title,
  description,
  actions,
  children,
  status,
}: {
  title: string;
  description: string;
  actions?: ReactNode;
  children: ReactNode;
  status?: ReactNode;
}) {
  return (
    <section className="ndrc-workbench">
      <header className="lab-header">
        <div>
          <h1>{title}</h1>
          <p>{description}</p>
        </div>
        <div className="lab-actions">{actions}</div>
      </header>
      {status}
      <div className="lab-content">{children}</div>
    </section>
  );
}
export function WorkbenchNotice({
  children,
  error = false,
}: {
  children: ReactNode;
  error?: boolean;
}) {
  return (
    <div
      className={error ? 'lab-notice lab-error' : 'lab-notice'}
      role={error ? 'alert' : 'status'}
    >
      {children}
    </div>
  );
}
export function WorkbenchStat({
  label,
  value,
  detail,
}: {
  label: string;
  value: ReactNode;
  detail?: string;
}) {
  return (
    <div className="lab-stat">
      <span>{label}</span>
      <strong>{value}</strong>
      {detail && <small>{detail}</small>}
    </div>
  );
}
export function WorkbenchField({ label, children }: { label: string; children: ReactNode }) {
  return (
    <label className="lab-field">
      <span>{label}</span>
      {children}
    </label>
  );
}
export function WorkbenchEmpty({ title, children }: { title: string; children?: ReactNode }) {
  return (
    <div className="lab-empty">
      <h2>{title}</h2>
      <p>{children}</p>
    </div>
  );
}
